import React, { useRef, useState } from 'react';
import { TABLE_DEFAULT_LIMIT } from '../../../util/constant';
import { toast, ToastContainer } from 'react-toastify';
import { get } from '../../../services/apiController';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import { months } from '../../../util/helper';
import PaginationInPage from '../../Pagination';
import Breadcrumb from '../../../components/Breadcrumb';
import { GrDocumentExcel } from 'react-icons/gr';
import LocationType from '../../../components/LocationTypeAndLocation/LocationType';
import LocationDropdown from '../../../components/LocationTypeAndLocation/Location';

const AgreementReports = () => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [agreementList, setAgreementList] = useState([]);
  const [headerFields, setHeaderFields] = useState([]);
  const clickToDownload = useRef(null);
  const [filters, setFilters] = useState({
    query: '',
    locationType: '',
    locationId: '',
    month: '',
    year: '',
  });

  const handleFilterChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const FetchReport = (condition) => {
    if (!filters.month || !filters.year) {
      return toast.error('Please select month and year to fetch data.');
    }
    let url = `/agreements/reports/?query=${filters.query}&month=${filters.month}&year=${filters.year}&locationType=${filters.locationType}&locationId=${filters.locationId}`;
    if (condition === 'download') {
      url += '&conditionType=download';
    } else {
      url += `&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`;
    }
    get(url)
      .then((res) => {
        if (condition === 'download') {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setTotalRecords(res?.data?.invoices?.count);
          setAgreementList(res?.data?.invoices?.rows);
          setHeaderFields(res?.data?.headerFields);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.data?.message || err?.response?.data?.message || err?.message));
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb navigation={[{ link: '#', title: 'Agreement Reports' }]} />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Reports | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Row className="align-items-center">
              <Col xs={3}>
                <Form.Group controlId="searchLocation">
                  <Form.Control
                    type="search"
                    placeholder="Search by ref. location"
                    name="query"
                    value={filters.query}
                    onChange={handleFilterChange}
                  />
                </Form.Group>
              </Col>
              <Col xs={3}>
                <Form.Group controlId="selectMonth">
                  <Form.Select name="month" value={filters.month} onChange={handleFilterChange}>
                    <option value="">Select Month</option>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
                      <option key={item} value={item}>
                        {months[item]}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group controlId="selectLocationType" className="mt-2">
                  <LocationType name="locationType" value={filters.locationType} handleChange={handleFilterChange} />
                </Form.Group>
              </Col>
              <Col xs={3}>
                <Form.Group controlId="selectYear">
                  <Form.Select name="year" value={filters.year} onChange={handleFilterChange}>
                    <option value="">Select Year</option>
                    {[2021, 2022, 2023, 2024, 2025, 2026].map((item) => (
                      <option key={item} value={item}>
                        {item}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group controlId="selectLocationId" className="mt-2">
                  <LocationDropdown
                    name="locationId"
                    value={filters.locationId}
                    locationType={filters.locationType}
                    handleChange={handleFilterChange}
                  />
                </Form.Group>
              </Col>
              <Col xs={3}>
                <div className="d-flex align-items-center">
                  <Button onClick={() => FetchReport()} type="submit" className="btn app-btn-default dark-color me-2">
                    Apply
                  </Button>
                  {Array.isArray(agreementList) && agreementList.length > 0 && (
                    <GrDocumentExcel
                      title="Download locations"
                      className="react-icons green me-2"
                      onClick={() => FetchReport('download')}
                      style={{ cursor: 'pointer' }}
                    />
                  )}
                  <a ref={clickToDownload} href="/" target="_blank" className="d-none">
                    HiddenClick
                  </a>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    {headerFields.map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(agreementList) && agreementList.length > 0 ? (
                    agreementList.map((item, index) => {
                      const tdsAmount = item?.rentAmount / 10;
                      const gstAmount = item?.Agreement?.underGst ? (item?.Agreement?.gstRate / 100) * item?.rentAmount : 0;
                      return (
                        <tr key={index}>
                          <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                          <td>{item?.Agreement?.Branch?.name}</td>
                          <td>{item?.Agreement?.referenceLocation}</td>
                          <td>{item?.rentAmount}</td>
                          <td>{item?.maintenanceAmount}</td>
                          <td>{item?.Agreement?.underGst ? gstAmount : '-'}</td>
                          <td>{tdsAmount}</td>
                          <td>{item?.rentAmount + gstAmount + item?.maintenanceAmount - tdsAmount}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <td colSpan={8}>
                      <div className="alert alert-warning mb-0" role="alert">
                        <strong>No data available</strong>
                      </div>
                    </td>
                  )}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AgreementReports;
